export type DateTime = string

export enum ProductionTypes {
  SILENCIO = 'SILENCIO',
  AANINEN = 'AANINEN',
  SILENCIO_AANINEN = 'SILENCIO_AANINEN',
}
